import React from 'react'
import Head from 'next/head'

import Header from 'app/Homepage/components/Header'
import AccountApp from 'app/Homepage/pages/Account'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
    },
  }
}

export const AccountPage = () => {
  return (
    <>
      <Head>
        <title>Akun - Merdeka Mengajar</title>
      </Head>
      <AccountApp />
    </>
  )
}

const PageHeader = () => <Header title="Akun" showUserProfile={false} />

AccountPage.layoutOpts = {
  hasHeader: true,
  header: PageHeader,
}

export default AccountPage
